// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_m1-0";